const state = {
    token: null,
    title: "",
    hideNav: true,
    hideBack: true,
    mobile: null,
    sendList: [],
    acceptList: [],
    sendLists: [],
    acceptLists: [],
    dict: {},
    openid:'',
    headerShow:true,
    height: 2.68,
    top: 1.81,
    toPath:"",
    mapTitle: "",
};
export default state;
